module.exports = __webpack_public_path__ + "img/AS0770010.3022b6c9.jpg";